{
  "nav": {
    "section": "导航"
  },
  "auth": {
    "agree": "我同意",
    "createAccount": "创建账号",
    "createNewAccount": "创建新账号",
    "email": "电子邮箱",
    "login": "登录",
    "password": "密码",
    "recover_password": "恢复密码",
    "sign_up": "注册",
    "keep_logged_in": "保持登录",
    "termsOfUse": "使用条款",
    "reset_password": "重置密码"
  },
  "account": {
    "login": "登录",
    "logout": "退出登录",
    "credits": "积分",
    "balance": "余额",
    "loginTitle": "登录 / 注册",
    "loginDesc": "免密登录 —— 我们会把一键登录链接发到你的邮箱。",
    "emailLabel": "邮箱",
    "sendLink": "发送登录链接",
    "linkSent": "请查收邮箱",
    "linkSentDesc": "已向 {email} 发送登录链接,点击即可完成登录。",
    "invalidEmail": "请输入有效的邮箱地址。",
    "close": "关闭",
    "buyCredits": "购买积分",
    "buyTitle": "购买积分",
    "buyDesc": "为钱包充值。积分全站工具通用。",
    "popular": "热门",
    "bonusSuffix": "+{n} 赠送",
    "buyAction": "购买",
    "buyNote": "由 Stripe 安全支付,付款后积分立即到账。",
    "checkoutError": "发起支付失败,请重试。",
    "paySuccess": "支付成功,积分已到账。",
    "payCancel": "已取消支付。",
    "loginTitlePw": "登录",
    "signupTitle": "注册账号",
    "forgotTitle": "重置密码",
    "resetTitle": "设置新密码",
    "passwordLabel": "密码",
    "newPassword": "新密码",
    "confirmPassword": "确认密码",
    "signIn": "登录",
    "signUp": "注册",
    "sendReset": "发送重置链接",
    "updatePassword": "更新密码",
    "forgotLink": "忘记密码?",
    "noAccount": "还没有账号?",
    "haveAccount": "已有账号?",
    "checkInbox": "请查收邮箱",
    "resetSent": "已向 {email} 发送重置密码链接。",
    "signupConfirm": "已向 {email} 发送确认邮件,点击激活账号。",
    "pwTooShort": "密码至少 6 位。",
    "pwMismatch": "两次输入的密码不一致。",
    "loginFailed": "邮箱或密码错误。"
  },
  "404": {
    "title": "此页面已去钓鱼",
    "text": "如果您觉得这不对，请给我们发送消息",
    "back_button": "返回仪表板"
  },
  "typography": {
    "primary": "主要文本样式",
    "secondary": "次要文本样式"
  },
  "dashboard": {
    "versions": "版本",
    "setupRemoteConnections": "设置远程连接",
    "currentVisitors": "当前访问者",
    "charts": {
      "trendyTrends": "流行趋势",
      "showInMoreDetail": "显示更多细节",
      "showInLessDetail": "显示较少细节",
      "loadingSpeed": "加载速度",
      "topContributors": "主要贡献者",
      "showNextFive": "显示接下来的五个",
      "commits": "提交"
    },
    "info": {
      "componentRichTheme": "组件丰富的主题",
      "completedPullRequests": "已完成的拉取请求",
      "users": "用户",
      "points": "点数",
      "units": "单位",
      "exploreGallery": "探索画廊",
      "viewLibrary": "查看库",
      "commits": "提交",
      "components": "组件",
      "teamMembers": "团队成员"
    },
    "tabs": {
      "overview": {
        "title": "概述",
        "built": "使用 Vue.js 框架构建",
        "free": "对所有人完全免费",
        "fresh": "新鲜和清新的设计",
        "mobile": "响应式且优化移动",
        "components": "大量有用的组件",
        "nojQuery": "完全不使用 jQuery"
      },
      "billingAddress": {
        "title": "账单地址",
        "personalInfo": "个人信息",
        "firstName": "名字 & 姓氏",
        "email": "电子邮箱",
        "address": "地址",
        "companyInfo": "公司信息",
        "city": "城市",
        "country": "国家",
        "infiniteConnections": "无限连接",
        "addConnection": "添加连接"
      },
      "bankDetails": {
        "title": "银行详情",
        "detailsFields": "详情字段",
        "bankName": "银行名称",
        "accountName": "账户名称",
        "sortCode": "排序代码",
        "accountNumber": "账号",
        "notes": "备注",
        "sendDetails": "发送详情"
      }
    },
    "navigationLayout": "导航布局",
    "topBarButton": "顶部按钮",
    "sideBarButton": "侧边按钮"
  },
  "language": {
    "brazilian_portuguese": "葡萄牙语",
    "english": "英语",
    "spanish": "西班牙语",
    "simplified_chinese": "简体中文",
    "persian": "波斯语"
  },
  "menu": {
    "home": "首页",
    "seo-nav": "SEO 工具导航",
    "geo-nav": "GEO 生成式优化",
    "aeo-nav": "AEO 答案引擎优化",
    "llms-txt": "llms.txt 生成器",
    "ai-checker": "AI 可见度体检",
    "glossary": "AI SEO 词汇表",
    "schema-generator": "Schema 标记工具",
    "domain-namer": "AI 域名起名",
    "domain-namer-naming": "AI 起名",
    "domain-namer-autofill": "自动凑满",
    "domain-namer-rank": "候选排名",
    "articles": "文章",
    "tutorials": "教程",
    "news": "新闻",
    "backlinks": "外链发布",
    "auth": "授权",
    "buttons": "按钮",
    "timelines": "时间线",
    "dashboard": "仪表板",
    "billing": "计费",
    "login": "登录",
    "signUp": "注册",
    "signup": "注册",
    "preferences": "偏好",
    "payments": "支付",
    "pricing-plans": "定价计划",
    "payment-methods": "支付方式",
    "login-singup": "登录/注册",
    "recover-password": "找回密码",
    "recover-password-email": "找回密码邮件",
    "settings": "应用设置",
    "users": "用户管理",
    "projects": "项目",
    "404": "404 页面",
    "faq": "常见问题解答"
  },
  "footer": {
    "home": "首页",
    "about": "关于我们",
    "contact": "联系我们",
    "privacy": "隐私政策",
    "terms": "服务条款",
    "backlinks": "外链发布",
    "rights": "保留所有权利。",
    "tagline": "面向 AI 搜索时代的 SEO/GEO/AEO 工具导航与知识平台。",
    "lastUpdated": "最后更新"
  },
  "messages": {
    "all": "查看所有消息",
    "new": "来自 {name} 的新消息",
    "mark_as_read": "标记为已读"
  },
  "navbar": {
    "messageUs": "需要Web开发帮助吗？请联系我们。",
    "repository": "GitHub 仓库"
  },
  "notifications": {
    "all": "查看所有通知",
    "mark_as_read": "标为已读",
    "sentMessage": "{name} 给你发了一条消息",
    "uploadedZip": "{name} 上传了一个新的 Zip 文件 {type}",
    "startedTopic": "{name} 开始了一个新话题"
  },
  "user": {
    "language": "修改语言",
    "logout": "登出",
    "profile": "我的资料",
    "settings": "设置",
    "billing": "账单",
    "faq": "常见问题",
    "helpAndSupport": "帮助与支持",
    "projects": "项目",
    "account": "账户",
    "explore": "探索"
  },
  "treeView": {
    "basic": "基本型",
    "icons": "图标",
    "selectable": "可选择",
    "editable": "可编辑",
    "advanced": "高级"
  },
  "chat": {
    "title": "聊天"
  },
  "cards": {
    "cards": "卡片",
    "fixed": "固定的",
    "floating": "浮动的",
    "contentText": "独特的斑马条纹使它们成为人们最熟悉的动物之一。",
    "rowHeight": "行高",
    "title": {
      "dark": "暗色背景",
      "bright": "亮色卡片",
      "titleOnImageNoOverlay": "图像上的标题，但没有叠加",
      "normal": "标准卡",
      "overlayAndTextOnImage": "图像上有覆盖和文本的卡片",
      "stripeNoImage": "无图像条纹卡"
    },
    "button": {
      "main": "主要",
      "cancel": "取消"
    },
    "link": {
      "edit": "编辑",
      "setAsDefault": "设为默认",
      "delete": "删除",
      "traveling": "Traveling",
      "france": "法国",
      "review": "评论",
      "feedback": "反馈信息",
      "readFull": "阅读全文",
      "secondaryAction": "第二行为",
      "action1": "行为 1",
      "action2": "行为 2"
    }
  },
  "helpAndSupport": "帮助与支持",
  "aboutVuesticAdmin": "关于 Vuestic Admin",
  "search": {
    "placeholder": "搜索..."
  },
  "vuestic": {
    "search": "搜索",
    "noOptions": "未找到项目",
    "ok": "确认",
    "cancel": "取消",
    "uploadFile": "上传文件",
    "undo": "撤销",
    "dropzone": "将文件拖到此处上传",
    "fileDeleted": "文件已删除",
    "closeAlert": "关闭警告",
    "backToTop": "回到顶部",
    "toggleDropdown": "切换下拉菜单",
    "carousel": "轮播",
    "goPreviousSlide": "上一张幻灯片",
    "goNextSlide": "下一张幻灯片",
    "goSlide": "跳转到第 {index} 张幻灯片",
    "slideOf": "第 {index} 张，共 {length} 张",
    "close": "关闭",
    "openColorPicker": "打开颜色选择器",
    "colorSelection": "颜色选择",
    "colorName": "颜色 {color}",
    "decreaseCounter": "减少计数",
    "increaseCounter": "增加计数",
    "selectAllRows": "选择所有行",
    "sortColumnBy": "按 {name} 排序",
    "selectRowByIndex": "选择第 {index} 行",
    "resetDate": "重置日期",
    "nextPeriod": "下一个时间段",
    "switchView": "切换视图",
    "previousPeriod": "上一个时间段",
    "removeFile": "删除文件",
    "reset": "重置",
    "pagination": "分页",
    "goToTheFirstPage": "跳转到第一页",
    "goToPreviousPage": "跳转到上一页",
    "goToSpecificPage": "跳转到第 {page} 页",
    "goToSpecificPageInput": "输入页码以跳转",
    "goNextPage": "跳转到下一页",
    "goLastPage": "跳转到最后一页",
    "currentRating": "当前评分 {value} / {max}",
    "voteRating": "评分 {value} / {max}",
    "optionsFilter": "选项筛选",
    "splitPanels": "分割面板",
    "movePaginationLeft": "分页向左移动",
    "movePaginationRight": "分页向右移动",
    "resetTime": "重置时间",
    "closeToast": "关闭提示",
    "selectedOption": "已选选项",
    "noSelectedOption": "未选择选项",
    "breadcrumbs": "面包屑导航",
    "counterValue": "计数值",
    "selectedDate": "选择的日期",
    "selectedTime": "选择的时间",
    "progressState": "进度状态",
    "color": "颜色",
    "next": "下一步",
    "back": "上一步",
    "finish": "完成",
    "step": "步骤",
    "progress": "进度",
    "loading": "加载中",
    "sliderValue": "当前滑块值为 {value}",
    "switch": "切换",
    "inputField": "输入框",
    "fileTypeIncorrect": "文件类型不正确",
    "select": "选择一个选项"
  },
  "common": {
    "search": "搜索",
    "loading": "加载中...",
    "clearFilters": "清除筛选",
    "readMore": "阅读全文",
    "visit": "访问",
    "free": "免费",
    "aiFriendly": "AI 友好",
    "back": "返回",
    "noResults": "没有找到匹配的结果"
  },
  "articlesPage": {
    "badge": "技术文章",
    "heroTitle": "SEO/GEO/AEO 深度文章库",
    "heroSubtitle": "最新的搜索优化洞察、行业趋势分析和实战指南，帮助您紧跟 AI 搜索变化",
    "searchPlaceholder": "搜索文章标题、标签...",
    "categories": "分类",
    "all": "全部文章",
    "catSeo": "SEO",
    "catGeo": "GEO",
    "catAeo": "AEO",
    "catTools": "工具相关",
    "empty": "没有找到匹配的文章",
    "author": "作者：{name}",
    "readTime": "{n} 分钟阅读",
    "pageInfo": "第 {current} / {total} 页（共 {count} 篇）",
    "seoTitle": "SEO/GEO/AEO 深度文章 — AI搜索时代实操指南",
    "seoDescription": "收录SEO、GEO、AEO深度分析文章，分享AI搜索时代的网站优化实战经验。包含GEO优化指南、AEO策略、llms.txt配置、Schema标记等前沿话题。",
    "seoKeywords": "SEO文章,GEO优化,AEO策略,AI搜索优化,llms.txt,结构化数据"
  },
  "newsPage": {
    "badge": "行业新闻",
    "heroTitle": "SEO/GEO/AEO 行业动态",
    "heroSubtitle": "关注最新的搜索引擎算法更新和 AI 搜索发展趋势",
    "searchPlaceholder": "搜索新闻...",
    "categories": "分类",
    "all": "全部新闻",
    "impact": "影响程度",
    "impactAll": "全部",
    "impactHigh": "高影响",
    "impactMedium": "中影响",
    "impactLow": "低影响",
    "empty": "暂无匹配新闻",
    "readOriginal": "阅读全文",
    "noLink": "暂无原文链接",
    "pageInfo": "第 {current} / {total} 页（共 {count} 条新闻）",
    "seoTitle": "SEO/GEO资讯 — 搜索引擎与AI最新动态",
    "seoDescription": "跟踪Google算法更新、ChatGPT新功能、Perplexity动态、Claude搜索等AI搜索行业最新资讯。",
    "seoKeywords": "SEO资讯,Google算法更新,AI搜索动态,GEO新闻"
  },
  "tutorialsPage": {
    "badge": "在线课程",
    "heroTitle": "SEO/GEO/AEO 完整课程体系",
    "heroSubtitle": "从入门到精通，系统化学习最新搜索优化技能",
    "searchPlaceholder": "搜索课程...",
    "categories": "课程分类",
    "all": "全部课程",
    "catSeo": "SEO 课程",
    "catGeo": "GEO 课程",
    "catAeo": "AEO 课程",
    "level": "难度等级",
    "levelAll": "全部等级",
    "levelBeginner": "初级",
    "levelIntermediate": "中级",
    "levelAdvanced": "高级",
    "empty": "暂无匹配课程",
    "minutes": "{n} 分钟",
    "students": "{n} 学生",
    "lessons": "{n} 节课程",
    "viewCourse": "查看课程",
    "seoTitle": "SEO/GEO/AEO教程 — 搜索优化实战课程",
    "seoDescription": "系统化SEO、GEO、AEO实操教程，从入门到进阶，覆盖技术SEO、关键词研究、GA4数据分析等核心技能。",
    "seoKeywords": "SEO教程,GEO优化课程,AEO学习,搜索优化入门"
  },
  "detail": {
    "home": "首页",
    "articles": "文章",
    "news": "资讯",
    "tutorials": "教程",
    "backToArticles": "返回文章列表",
    "backToNews": "返回新闻列表",
    "backToTutorials": "返回教程列表",
    "relatedArticles": "相关文章",
    "relatedNews": "相关资讯",
    "relatedTutorials": "相关教程",
    "related": "相关内容",
    "prev": "上一篇",
    "next": "下一篇",
    "notFoundArticle": "文章不存在",
    "notFoundNews": "新闻不存在",
    "notFoundTutorial": "教程不存在",
    "glossaryTooltip": "查看术语解释",
    "instructor": "讲师：{name}",
    "lessonsCount": "{n} 节课",
    "studentsCount": "{n} 学员",
    "overview": "课程概述",
    "outline": "课程大纲",
    "lessonsTotal": "共 {n} 节",
    "comingSoon": "课程内容正在整理中，敬请期待",
    "durationMin": "{n} 分钟",
    "durationHour": "{h} 小时",
    "durationHourMin": "{h} 小时 {m} 分钟"
  },
  "notFound": {
    "title": "页面未找到",
    "text": "您访问的页面不存在或已被移除，请返回首页继续探索。",
    "back": "返回首页"
  },
  "seoNavPage": {
    "badge": "SEO 工具导航",
    "heroTitle": "发现最好用的 SEO 工具",
    "heroSubtitle": "{n}+ 款精选专业 SEO 工具,覆盖 {c} 大核心领域——关键词研究、技术审计、内容优化与 AI 搜索监测",
    "searchPlaceholder": "按名称、功能或标签搜索工具...",
    "searchAria": "搜索 SEO 工具",
    "statTools": "精选工具",
    "statFree": "免费",
    "statAi": "AI 友好",
    "statCategories": "分类",
    "filterFreeOnly": "仅免费",
    "filterAi": "AI 友好",
    "allTools": "全部工具",
    "featuredTitle": "精选推荐",
    "featuredDesc": "每个站长都需要的核心工具——均经实战检验",
    "visitAria": "访问 {name}(在新标签页打开)",
    "badgeFree": "免费",
    "badgeAi": "AI 友好",
    "badgeApi": "API",
    "badgeAiShort": "AI",
    "toolsFound": "个工具",
    "toolsUnit": "个工具",
    "viewAllInCategory": "查看全部 {count} 个",
    "clearFilters": "清除筛选",
    "empty": "没有匹配的工具——换个关键词试试",
    "visitHint": "访问",
    "tipsTitle": "给站长的 SEO 建议",
    "tip1Title": "从关键词研究开始",
    "tip1Body": "用 <strong>Exploding Topics</strong> 发现爆发性热词,用 <strong>AnswerThePublic</strong> 挖掘真实用户问题,再用 <strong>Google Keyword Planner</strong> 验证搜索量。",
    "tip2Title": "定期做技术体检",
    "tip2Body": "每月用 <strong>Screaming Frog</strong> 全站爬取,用 <strong>PageSpeed Insights</strong> 检查 Core Web Vitals,并及时修复技术 SEO 问题。",
    "tip3Title": "AI 辅助内容优化",
    "tip3Body": "用 <strong>SurferSEO</strong> 或 <strong>Clearscope</strong> 为内容打分,再用 <strong>Frase.io</strong> 快速生成高排名文章大纲。",
    "tip4Title": "为 AI 搜索时代做准备",
    "tip4Body": "用 <strong>GEO/AEO Tracker</strong> 追踪品牌在各 AI 工具中的被引用频率,用 <strong>SearchAttention</strong> 提升在 Google AI Overviews 中的可见度。",
    "tip5Title": "建设高质量外链",
    "tip5Body": "用 <strong>Majestic</strong> 分析竞品外链来源,再用 <strong>Respona</strong> 或 <strong>BacklinkGPT</strong> 自动化外链触达。",
    "tip6Title": "用数据驱动决策",
    "tip6Body": "结合 <strong>Google Search Console</strong> 数据与来自 <strong>Similarweb</strong> 的竞品流量,精准定位最大的增长机会。",
    "seoTitle": "SEO 工具导航 — 100+ 精选 SEO 工具",
    "seoDescription": "精选 100+ 款 SEO 工具,涵盖关键词研究、外链分析、技术 SEO、内容优化与本地 SEO,助你在 Google 获得更高排名,免费工具已标注。",
    "seoKeywords": "SEO工具,关键词研究工具,外链分析,技术SEO,Ahrefs,Semrush,Google Search Console"
  },
  "geoNavPage": {
    "badge": "GEO · AEO · AI 搜索导航",
    "heroTitleMain": "生成式引擎优化工具",
    "heroTitleAccent": "完整导航",
    "heroSubtitle": "精选 <strong>{n}+</strong> 款工具与资源,覆盖 6 大类别——<strong>中国 SaaS</strong>、<strong>中国服务商</strong>、<strong>全球工具</strong>、<strong>SEO 插件</strong>、<strong>免费工具</strong>、<strong>开源项目</strong>",
    "searchPlaceholder": "按名称、功能或标签搜索工具...",
    "searchAria": "搜索 GEO 工具",
    "regionAll": "全部",
    "regionCn": "🇨🇳 中国工具",
    "regionGlobal": "🌍 全球工具",
    "statTools": "精选工具",
    "statFree": "含免费版",
    "statOss": "开源项目",
    "concept1": "<strong>GEO</strong> = 生成式引擎优化",
    "concept2": "<strong>AEO</strong> = 答案引擎优化",
    "concept3": "<strong>llms.txt</strong> = AI 可读结构标准",
    "filterHasFree": "含免费",
    "filterOpenSource": "开源",
    "allTools": "全部工具",
    "featuredTitle": "精选推荐",
    "featuredBadge": "编辑精选",
    "visitAria": "访问 {name}(在新标签页打开)",
    "badgeFree": "免费",
    "badgeFreeTier": "含免费版",
    "badgeHasFree": "含免费",
    "badgeOss": "开源",
    "badgeApi": "API",
    "badgeCn": "🇨🇳 中国",
    "badgeGlobal": "🌍 全球",
    "resultCount": "找到 <strong>{n}</strong> 个工具",
    "clearFilters": "清除筛选",
    "clearAllFilters": "清除所有筛选",
    "empty": "没有匹配的工具——换个关键词试试",
    "toolsUnit": "个工具",
    "viewAllInCategory": "查看全部 {count} 个",
    "visitHint": "访问",
    "tipsTitle": "GEO 实战手册",
    "tip1Title": "第 1 步:摸清现状基线",
    "tip1Body": "用 <strong>Lens GEO</strong>(免费)或 <strong>HubSpot AI Grader</strong>(免费)快速评估品牌在主流 AI 引擎中的可见度,判断是否需要系统性优化。",
    "tip2Title": "第 2 步:添加 llms.txt",
    "tip2Body": "用 <strong>aeo.js</strong> 或 <strong>LLMrefs 的 llms.txt 生成器</strong>(免费)添加 llms.txt 文件,告诉 AI 爬虫你网站的核心结构——这是 GEO 的基础工作。",
    "tip3Title": "第 3 步:结构化数据",
    "tip3Body": "为关键页面添加 JSON-LD Schema(Article、FAQ、Organization),并用 <strong>Google Rich Results Test</strong> 验证——结构化数据是 AI 引擎理解你的实体的关键。",
    "tip4Title": "第 4 步:提升内容质量",
    "tip4Body": "普林斯顿 KDD 2024 研究表明,加入 <strong>统计数据</strong>、<strong>FAQ 格式</strong>、<strong>权威引用</strong> 和清晰的 <strong>标题层级</strong> 能显著提升 AI 引用率。可用 <strong>Frase.io</strong> 辅助内容分析。",
    "tip5Title": "第 5 步:持续监测",
    "tip5Body": "国内可试 <strong>ImpetaAI</strong>(50+ 指标)或 <strong>GEOWISE</strong>(内容+监测);全球可试 <strong>Otterly.AI</strong>(29 美元/月)或 <strong>Profound</strong>(企业级)。",
    "tip6Title": "第 6 步:建设 E-E-A-T",
    "tip6Body": "在 <strong>Wikidata</strong> 建立品牌实体,并通过 <strong>传声岗</strong>(128 家央媒)或其他权威媒体,提升品牌在 AI 引擎中的 E-E-A-T 信任信号。",
    "seoTitle": "GEO 工具导航 — 生成式引擎优化工具",
    "seoDescription": "精选 60+ 款 GEO(生成式引擎优化)工具,助你的内容被 ChatGPT、Perplexity、Google AI Overviews 等 AI 搜索引擎引用,涵盖 AI 可见度监测、品牌提及分析与 llms.txt。",
    "seoKeywords": "GEO工具,生成式引擎优化,AI搜索优化,ChatGPT SEO,Perplexity优化,AI可见度"
  },
  "aeoNavPage": {
    "badge": "AEO · 答案引擎优化导航",
    "heroTitleMain": "答案引擎优化工具",
    "heroTitleAccent": "完整导航",
    "heroSubtitle": "精选 <strong>{n}+</strong> 款工具与资源,覆盖 6 大类别——<strong>AEO 专注型 SaaS</strong>、<strong>企业级 SEO 模块</strong>、<strong>内容优化</strong>、<strong>问题研究</strong>、<strong>结构化数据</strong>、<strong>中国平台</strong>",
    "searchPlaceholder": "按名称、功能或标签搜索工具...",
    "searchAria": "搜索 AEO 工具",
    "concept1": "<strong>AEO</strong> = 答案引擎优化",
    "concept2": "<strong>llms.txt</strong> = AI 可读结构标准",
    "concept3": "<strong>JSON-LD</strong> = 结构化数据标记",
    "concept4": "<strong>PAA</strong> = People Also Ask 答案框",
    "statTools": "精选工具",
    "statOss": "⭐ 开源项目",
    "statFree": "🆓 含免费版",
    "statChina": "🇨🇳 中国平台",
    "filterHasFree": "含免费",
    "filterOpenSource": "开源",
    "allTools": "全部工具",
    "featuredTitle": "精选推荐",
    "featuredBadge": "编辑精选",
    "visitAria": "访问 {name}(在新标签页打开)",
    "badgeFree": "免费",
    "badgeFreeTier": "含免费版",
    "badgeHasFree": "含免费",
    "badgeOss": "开源",
    "badgeApi": "API",
    "resultCount": "找到 <strong>{n}</strong> 个工具",
    "clearFilters": "清除筛选",
    "clearAllFilters": "清除所有筛选",
    "empty": "没有匹配的工具——换个关键词试试",
    "toolsUnit": "个工具",
    "viewAllInCategory": "查看全部 {count} 个",
    "visitHint": "访问",
    "tipsTitle": "AEO 实战手册",
    "tip1Title": "第 1 步:评估 AI 可见度基线",
    "tip1Body": "用 <strong>Otterly.AI</strong>(29 美元/月,15,000+ 用户)或 <strong>GetCito/Elmo</strong>(开源,免费)快速评估品牌在 ChatGPT、Perplexity、Gemini 中的曝光基线。面向中国市场的品牌,<strong>Lens GEO</strong>(免费)是首选。",
    "tip2Title": "第 2 步:挖掘 AEO 问题关键词",
    "tip2Body": "用 <strong>AlsoAsked</strong>(可视化 PAA 问题树)和 <strong>AnswerThePublic</strong>(5W1H 问题聚合)发现真实用户意图,优先覆盖 AI 最常引用的高频问题。",
    "tip3Title": "第 3 步:撰写答案友好型内容",
    "tip3Body": "用 <strong>Frase.io</strong>(AI 摘要 + FAQ 生成,14.99 美元/月)或 <strong>Surfer SEO</strong>(内容打分 + LLM 优化)撰写清晰、语义完整、既能在 Google 排名又能被 AI 引用的内容。",
    "tip4Title": "第 4 步:添加结构化数据",
    "tip4Body": "WordPress 上用 <strong>Rank Math</strong> 自动生成 FAQ/HowTo Schema;现代框架上用 <strong>aeo.js</strong>(⭐76)一键生成 llms.txt + JSON-LD;再用 <strong>Google Rich Results Test</strong>(免费)验证。",
    "tip5Title": "第 5 步:扩展到企业级",
    "tip5Body": "已有 SEO 工具栈的团队可启用 <strong>Semrush AI Visibility</strong> 或 <strong>Ahrefs Brand Radar</strong> 中的 AEO 模块——无需更换现有工具即可延伸到 AEO。",
    "tip6Title": "第 6 步:覆盖中国 AI 引擎",
    "tip6Body": "面向中国市场,用 <strong>AIDSO</strong>(DSO+GEO+AEO 一体)或 <strong>易山科技</strong>(7 套自研系统)覆盖豆包、DeepSeek、Kimi、通义千问等主流国内平台,构建 AI 可见度优势。",
    "seoTitle": "AEO 工具导航 — 答案引擎优化工具",
    "seoDescription": "精选 50+ 款 AEO(答案引擎优化)工具,助你的内容出现在 Google 精选摘要、AI 直接回答与语音搜索中,涵盖 Schema 生成器、摘要优化与结构化数据校验工具。",
    "seoKeywords": "AEO工具,答案引擎优化,精选摘要,Schema标记,结构化数据,语音搜索优化"
  },
  "aiCheckerPage": {
    "badge": "AI 搜索可见度 · 检测工具聚合",
    "heroTitleMain": "AI 搜索可见度",
    "heroTitleAccent": "完整导航",
    "heroSubtitle": "聚合 <strong>{n}+</strong> 款 AI 可见度检测工具,覆盖 <strong>9 大中国 AI 引擎</strong> 与 <strong>主流全球 AI 平台</strong>——从免费快查到企业级监测,助品牌全面了解自身的 AI 搜索曝光",
    "journey1": "选择检测工具",
    "journey2": "获取报告",
    "journey3": "发现差距",
    "journey4": "优化",
    "journey5": "复查",
    "searchPlaceholder": "按名称、平台或功能搜索工具...",
    "searchAria": "搜索 AI 可见度工具",
    "regionCn": "🇨🇳 中国工具",
    "regionGlobal": "🌍 全球工具",
    "statTools": "精选工具",
    "statFree": "含免费版",
    "filterFreeOnly": "仅免费",
    "allTools": "全部工具",
    "featuredTitle": "快速检测",
    "featuredBadge": "免费、直接",
    "visitAria": "访问 {name}(在新标签页打开)",
    "badgeFree": "免费",
    "badgeFreeTier": "含免费版",
    "badgeHasFree": "含免费",
    "badgeApi": "API",
    "badgeCn": "🇨🇳 中国",
    "badgeGlobal": "🌍 全球",
    "resultCount": "找到 <strong>{n}</strong> 个工具",
    "clearFilters": "清除筛选",
    "clearAllFilters": "清除所有筛选",
    "empty": "没有匹配的工具——换个关键词试试",
    "toolsUnit": "个工具",
    "visitHint": "访问",
    "tipsTitle": "检测之后如何提升 AI 可见度",
    "tip1Title": "第 1 步:免费基线检测",
    "tip1Body": "用 <strong>Lens GEO</strong>(中国)或 <strong>AppearOnAI</strong>(全球,免费)获取一份基线 AI 可见度报告,确认主流 AI 引擎是否提及你的品牌。",
    "tip2Title": "第 2 步:添加 llms.txt",
    "tip2Body": "用 <strong>llms.txt 生成器</strong> 创建 llms.txt 文件,告诉 AI 爬虫你网站的核心内容——这是提升 AI 可见度最基础的一步。",
    "tip3Title": "第 3 步:结构化数据",
    "tip3Body": "为重要页面添加 JSON-LD Schema(Article、FAQ、Organization),并用 <strong>Google Rich Results Test</strong> 验证,帮助 AI 引擎理解你的实体。",
    "tip4Title": "第 4 步:提升内容质量",
    "tip4Body": "加入 <strong>统计数据</strong>、<strong>FAQ 格式</strong> 和 <strong>权威引用</strong>,并用 <strong>Frase.io</strong> 分析 AI 引用的内容模式——大幅提高被引用概率。",
    "tip5Title": "第 5 步:持续监测",
    "tip5Body": "国内可选 <strong>SheepGeo</strong>(9 个模型)或 <strong>ImpetaAI</strong>(50+ 指标);全球可选 <strong>Otterly.AI</strong>(29 美元/月)进行持续追踪,养成复查习惯。",
    "tip6Title": "第 6 步:每月复查",
    "tip6Body": "AI 引擎每月更新模型与训练数据,因此应 <strong>每月</strong> 用免费工具复查可见度,追踪效果并及时调整策略。",
    "seoTitle": "AI Mode SEO 检测工具 — 测试你在 AI 搜索中的可见度",
    "seoDescription": "检测你的网站在 Google AI Mode、AI Overviews、ChatGPT、Perplexity、Claude、Gemini 中的提及与引用情况,对比免费与付费 AI Mode SEO 检测工具,提升 AI 搜索可见度。",
    "seoKeywords": "AI Mode SEO检测,AI Overviews检测,AI可见度检测,GEO检测,ChatGPT可见度,AI搜索优化",
    "faqSectionTitle": "AI Mode SEO 检测 — 常见问题",
    "faq1Q": "什么是 AI Mode SEO 检测工具?",
    "faq1A": "AI Mode SEO 检测工具衡量你的品牌与页面是否被 AI 搜索答案提及、引用或链接——包括 Google AI Mode、AI Overviews、ChatGPT、Perplexity、Claude、Gemini——而不仅仅是传统的蓝色链接排名。",
    "faq2Q": "如何检查网站在 Google AI Mode 中的表现?",
    "faq2A": "从上方列表选择一款检测工具,输入你的域名或目标查询,工具会对各 AI 引擎发起查询并报告你的被引用位置。AppearOnAI 等免费工具可快速建立基线;付费平台提供持续监测。",
    "faq3Q": "为什么网站排在 Google 首页,却不出现在 AI 回答里?",
    "faq3A": "AI 引擎偏好易于引用的内容:提问式标题、简明直接的回答、统计数据、原创数据与 FAQ 结构化标记。传统排名有帮助,但缺少答案化、结构化的内容时,AI 通常引用别人。",
    "faq4Q": "AI 可见度检测之后该做什么?",
    "faq4A": "按本页步骤执行:先做免费基线检测,添加 llms.txt,部署 Article 与 FAQ 结构化数据,用统计与权威引用强化内容,然后每月复查——AI 回答会随模型与训练数据更新而变化。"
  },
  "glossaryPage": {
    "badge": "AI SEO 术语库 · {n}+ 条术语",
    "heroTitleMain": "完整的 AI SEO 术语库",
    "heroTitleAccent": "GEO · AEO · LLMO 等",
    "heroSubtitle": "覆盖 <strong>{n}+</strong> 条核心术语,横跨 5 大类别——<strong>AI 搜索优化</strong>、<strong>传统 SEO</strong>、<strong>LLM 技术</strong>、<strong>结构化数据</strong> 与 <strong>指标度量</strong>——全站内链的中枢。",
    "searchPlaceholder": "搜索术语、名称或定义...",
    "searchAria": "搜索术语库",
    "sidebarCategory": "按类别浏览",
    "allTerms": "全部术语",
    "sidebarAlpha": "字母索引",
    "resultShowing": "显示 <strong>{n}</strong> / {total} 条术语",
    "clearFilters": "清除筛选",
    "empty": "没有匹配的术语",
    "viewTool": "查看工具",
    "related": "相关:",
    "ctaQuestion": "没找到你需要的术语?",
    "ctaSuggest": "推荐一个术语 →",
    "footerMeta": "最后更新:2026 年 5 月 · {n} 条术语",
    "seoTitle": "SEO/GEO/AEO 术语库 — 搜索优化术语详解",
    "seoDescription": "详解 200+ 条 SEO、GEO、AEO 术语,涵盖技术 SEO、内容优化、生成式引擎优化与结构化数据,面向新手与专家的搜索优化词典。",
    "seoKeywords": "SEO术语,GEO术语,AEO术语,搜索优化词典,Schema术语,什么是llms.txt"
  },
  "llmsTxtPage": {
    "badge": "llms.txt · AI 可读的网站名片",
    "heroTitleMain": "llms.txt",
    "heroTitleAccent": "工具导航",
    "heroSub": "类似 <strong>robots.txt</strong>,但专为 <strong>大型 AI 模型</strong> 而生——它告诉 ChatGPT、Perplexity、Gemini 你的网站提供什么。由 <strong>Jeremy Howard(fast.ai)</strong> 于 2024 年提出,如今已成为 GEO/AEO 的核心基础设施标准。",
    "statSpecYear": "📅 规范年份",
    "statToolsListed": "🔧 收录工具",
    "statTemplates": "📋 内置模板",
    "statFreeVal": "免费",
    "statAllFree": "✨ 全部免费",
    "concept1": "<strong>llms.txt</strong> = AI 可读结构标准",
    "concept2": "<strong>GEO/AEO</strong> 基础设施必备",
    "concept3": "格式:Markdown + 链接列表",
    "tabTools": "推荐工具",
    "tabTemplates": "模板库",
    "tabGuide": "格式指南",
    "tplIntro": "按行业分类的 llms.txt 模板——点击复制,粘贴到任意编辑器调整后,上传到你的网站根目录。",
    "copyBtn": "复制模板",
    "copiedBtn": "已复制!",
    "tplHowTitle": "如何使用模板",
    "tplHow1": "点击「复制模板」把内容复制到剪贴板",
    "tplHow2": "粘贴到任意文本编辑器,修改网站名称、链接和描述以匹配你的网站",
    "tplHow3": "将文件保存为 <code>llms.txt</code> 并上传到网站根目录",
    "tplHow4": "访问 <code>https://yoursite.com/llms.txt</code> 验证可访问性",
    "tplHow5": "打开「推荐工具」→「提交与收录平台」提交收录",
    "gWhatTitle": "什么是 llms.txt?",
    "gWhatP1": "<code>llms.txt</code> 是放在网站根目录的纯文本文件,专为大型 AI 模型设计——它告诉 LLM「<strong>这个网站是做什么的、哪些页面值得阅读、该如何理解它</strong>」。",
    "gWhatP2": "由 <strong>Jeremy Howard(fast.ai 创始人)</strong> 于 2024 年提出。正如 <code>robots.txt</code> 面向搜索引擎爬虫,<code>llms.txt</code> 是面向 AI 模型的语义索引。Cloudflare、Anthropic、Perplexity 等生态工具已开始读取它。",
    "gFormatTitle": "标准格式",
    "gFormatCode": "# 网站名称\n\n> 用一句话描述这个网站是做什么的\n\n## 核心页面\n- [页面名称](URL): 简短说明\n- [关于我们](https://example.com/about): 公司简介\n\n## 产品 / 服务\n- [产品 A](https://example.com/product): 功能说明\n\n## 可选\n- [博客](https://example.com/blog): 文章",
    "gFormatNote": "最简格式:Markdown + 链接列表,让 LLM 一眼读懂你的网站结构。",
    "gBestTitle": "撰写最佳实践",
    "gBest1": "<strong>把一句话描述写精准</strong>:包含业务类型 + 目标用户 + 核心价值",
    "gBest2": "<strong>把链接描述写具体</strong>:避免「阅读更多」,清楚说明页面内容",
    "gBest3": "<strong>用 Optional 设置优先级</strong>:核心内容靠前,次要内容放在 Optional",
    "gBest4": "<strong>保持简洁</strong>:每个板块 3–8 个链接为宜",
    "gBest5": "<strong>定期更新</strong>:网站大改版后及时刷新 llms.txt",
    "gDeployTitle": "如何部署",
    "gDeploy1": "用模板库撰写或复制一份适合你网站的 <code>llms.txt</code>",
    "gDeploy2": "将文件上传到网站根目录(与 <code>robots.txt</code> 同级)",
    "gDeploy3": "验证可访问性:<code>https://yoursite.com/llms.txt</code>",
    "gDeploy4": "提交到 AI 收录平台以获得更多曝光",
    "gVsTitle": "对比 robots.txt",
    "cmpDimension": "维度",
    "cmpAudience": "受众",
    "cmpAudienceR": "搜索引擎爬虫",
    "cmpAudienceL": "大型 AI 模型(LLM)",
    "cmpFunc": "核心功能",
    "cmpFuncR": "控制抓取权限",
    "cmpFuncL": "提供语义理解",
    "cmpFormat": "格式",
    "cmpFormatR": "指令语法",
    "cmpFormatL": "Markdown 描述",
    "cmpIntro": "诞生年份",
    "cmpRole": "GEO/AEO 作用",
    "cmpRoleR": "间接",
    "cmpRoleL": "直接提升 AI 引用率",
    "seoTitle": "llms.txt 工具 — AI 爬虫网站索引配置",
    "seoDescription": "llms.txt 生成器、校验器与模板一站集合。构建 AI 可读的语义索引文件,让 ChatGPT、Perplexity、Claude 等 AI 模型更好地理解并引用你的网站内容。",
    "seoKeywords": "llms.txt,AI爬虫配置,AI索引文件,ChatGPT网站索引,Perplexity,AI可见度"
  },
  "schemaGeneratorPage": {
    "badge": "结构化数据 · Schema 标记工具",
    "heroTitleMain": "Schema 标记生成器",
    "heroTitleAccent": "导航与模板中心",
    "heroSubtitle": "聚合 <strong>{n}+</strong> 款 Schema 生成器与工具,覆盖 <strong>{c}</strong> 种常见类型,附 JSON-LD 模板与字段说明——快速为网站添加结构化数据,提升富结果与 AI 引用。",
    "wf1": "选择 Schema 类型",
    "wf2": "用工具生成代码",
    "wf3": "复制 JSON-LD 模板",
    "wf4": "Google 官方校验 ✅",
    "schemaSuffix": "Schema",
    "aeoTipTitle": "AEO 关键提示",
    "requiredFields": "必填字段",
    "jsonLdTemplate": "JSON-LD 模板代码",
    "copyCode": "复制代码",
    "copiedCode": "已复制!",
    "recommendedTools": "推荐工具",
    "priceFree": "免费",
    "pricePaid": "付费",
    "openTool": "打开工具",
    "hasFreeTier": "含免费版",
    "levelBeginner": "适合新手",
    "levelAdvanced": "进阶",
    "levelAuto": "全自动",
    "validateTip": "生成代码后,务必用 <strong>Google Rich Results Test</strong> 和 <strong>Schema.org Validator</strong> 校验",
    "allPurpose": "🥇 全能首选",
    "aiAuto": "🤖 AI 自动化",
    "aiAutoTip": "适合 WordPress 站长,或想要「配置一次、长期自动运行」的人",
    "implTips": "落地实施提示",
    "tip1": "JSON-LD 放在 <code>&lt;head&gt;</code> 或 <code>&lt;body&gt;</code> 都可以",
    "tip2": "同一页面可叠加多种 Schema 类型",
    "tip3": "FAQ Schema 最利于 AI 搜索引用",
    "tip4": "部署后 1–2 周 Google 开始识别",
    "tip5": "每次内容更新后重新校验 Schema",
    "seoTitle": "FAQ Schema 生成器 — 免费 JSON-LD 结构化数据工具",
    "seoDescription": "免费 FAQ Schema 生成器与 JSON-LD 标记工具。生成并校验 FAQ、Article、Product、HowTo 等 20+ 种 Schema 类型,复制即可用的代码助你赢得富结果与 AI 引用。",
    "seoKeywords": "FAQ Schema生成器,Schema标记生成器,JSON-LD生成,结构化数据工具,FAQ Schema,Article Schema,富结果",
    "faqSectionTitle": "FAQ Schema 生成器 — 常见问题",
    "faq1Q": "什么是 FAQ Schema 生成器?",
    "faq1A": "FAQ Schema 生成器把你的问答内容转换成 FAQPage JSON-LD 结构化数据。将生成的代码粘贴到页面中,Google 可以把你的问答展示为富结果,AI 搜索引擎也更容易解析与引用。",
    "faq2Q": "如何用本页生成 FAQ Schema 标记?",
    "faq2A": "在上方选择 FAQ 类型,复制 JSON-LD 模板,把示例问答替换成你自己的内容,再将代码粘贴到页面的 head 或 body 中。最后用工具面板里的 Google Rich Results Test 校验。",
    "faq3Q": "2026 年 FAQ Schema 对 SEO 还有帮助吗?",
    "faq3A": "有。Google 现在主要对权威站点展示 FAQ 富结果,但 FAQPage 标记仍是机器可读性最强的问答格式之一,有利于 AI Overviews、ChatGPT、Perplexity 的引用,也能帮助传统搜索理解页面实体。",
    "faq4Q": "这里还能生成哪些 Schema 类型?",
    "faq4A": "除 FAQ 外,本导航还覆盖 Article、Product、HowTo、BreadcrumbList、Organization、Video、NewsArticle 等 20+ 种 JSON-LD 类型,每种都附可复制模板、必填字段说明与推荐生成器、校验工具。"
  },
  "domainNamerPage": {
    "badge": "AI 起名 · 域名与品牌撞名检测",
    "heroTitleMain": "AI 域名起名",
    "heroTitleAccent": "起好名 · 查域名 · 不撞名",
    "heroSubtitle": "一句话描述你的需求,AI 起一批适合做品牌的英文名,并即时查询域名能否注册(RDAP)与 Google 撞名风险,只留下你真正能注册的名字。",
    "needLabel": "用一句话描述你想做什么(中英文均可)",
    "needPlaceholder": "例如:一个帮独立开发者批量管理 API key 的工具;或:面向宠物主人的 AI 健康记录 App",
    "tldLabel": "查询哪些后缀(点击切换,可自定义添加)",
    "tldAddPlaceholder": "输入后缀,如 .dev / .xyz(带不带点都行)",
    "tldAddBtn": "添加",
    "autofillLabel": "自动凑满可用候选(撞名/被占的自动跳过,多轮直到够数)",
    "autofillTargetLabel": "目标可用数量(无撞名 + 有可注册域名)",
    "autofillHint": "最多自动起 8 轮;够数即停,不够则返回已凑到的。",
    "runBtn": "开始起名",
    "haveCandidates": "已经有候选名了?直接查域名 + 撞名并排名",
    "myNamesLabel": "粘贴你的候选名(每行一个,或用逗号/空格分隔;带不带后缀都行)",
    "myNamesPlaceholder": "例如:\nRollpik\nTieronic\nmybrand.com",
    "rankBtn": "查询并排名我的候选",
    "recoTitle": "AI 综合推荐",
    "moreBtn": "🔄 继续推荐(再起一批,综合所有结果)",
    "brandChecking": "撞名检测…",
    "brandClash": "疑似撞名",
    "brandClear": "无明显撞名",
    "brandFailed": "撞名查询失败",
    "viewLink": "查看 ↗",
    "regYearSuffix": "年注册",
    "unknownTag": "待确认",
    "takenGroup": "已占用 / 撞名({n} 个,点击展开/收起)",
    "legendAvailable": "可注册",
    "legendRegistered": "已被注册",
    "legendUnknown": "查询异常",
    "seoTitle": "AI 域名起名 — 智能生成品牌名并查询域名可注册",
    "seoDescription": "免费的 AI 域名起名工具:一句话描述产品,AI 生成适合做品牌的英文名,并即时查询域名能否注册与 Google 撞名风险。为创业者和独立开发者打造。",
    "seoKeywords": "AI域名生成,域名起名,品牌起名,域名查询,公司起名,产品起名,startup naming"
  },
  "domainNamerAutofillPage": {
    "heroAccent": "自动凑够你要的个数",
    "heroSubtitle": "设定一个目标可用数量,AI 会多轮持续起名、自动跳过被占用或撞名的名字,直到凑够你要的数量。",
    "runBtn": "开始自动凑满",
    "seoTitle": "AI 域名批量生成 — 自动凑满可注册域名",
    "seoDescription": "设定目标个数,让 AI 多轮自动生成这么多个可注册、不撞名的域名,自动跳过被占用和撞名的名字。",
    "seoKeywords": "批量域名生成,域名批量查询,自动域名生成,可注册域名,创业起名"
  },
  "domainNamerRankPage": {
    "heroMain": "给你的候选名排名",
    "heroAccent": "查域名 + 撞名,自动排序",
    "heroSubtitle": "已经有一批候选名了?把它们粘进来,我们会逐个查域名可注册情况与 Google 撞名风险,再按可用度排序。",
    "seoTitle": "域名候选排名 — 批量查可注册与撞名",
    "seoDescription": "粘贴你自己的候选名,即时逐个查询域名可注册情况(RDAP)与 Google 撞名风险,再按可用度排序。免费。",
    "seoKeywords": "域名查询,批量域名检测,撞名检测,域名排名,候选名查询"
  }
}
